import { BREAKPOINTS, MAX_IMAGE_WIDTH } from 'src/app/utils/global-constants';

import { ImageSizeType } from './image-size-type.enum';

const imageThresholdStep = 100;

/**
 * Round given image size to the next bigger threshold size.
 */
export function getImageSizeThreshold(width: number): number {
  return Math.min(MAX_IMAGE_WIDTH, Math.max(1, Math.ceil(width / imageThresholdStep)) * imageThresholdStep);
}

/**
 * Basic retina queries
 */
const retinaQueries = [
  '(-webkit-min-device-pixel-ratio: 2)',
  '(min--moz-device-pixel-ratio: 2)',
  '(-o-min-device-pixel-ratio: 2/1)',
  '(min-device-pixel-ratio: 2)',
  '(min-resolution: 192dpi)',
  '(min-resolution: 2dppx)'
];

/**
 * Raw responsive sizes map:  [viewport min-width]: [image width in pixels]
 */
export const imageResponsiveSizesRaw: { [key: string]: { [key: number]: number } } = {
  [ImageSizeType.OneColumn]: {
    0: 432,
    [BREAKPOINTS[0]]: 691,
    [BREAKPOINTS[1]]: 880,
    [BREAKPOINTS[2]]: 1100,
    [BREAKPOINTS[3]]: 1240,
    [BREAKPOINTS[4]]: 1680
  },

  [ImageSizeType.TwoToOneColumns]: {
    0: 432,
    [BREAKPOINTS[0]]: 691,
    [BREAKPOINTS[1]]: 425,
    [BREAKPOINTS[2]]: 550,
    [BREAKPOINTS[3]]: 620,
    [BREAKPOINTS[4]]: 840
  },

  [ImageSizeType.ThreeToOneColumns]: {
    0: 432,
    [BREAKPOINTS[0]]: 691,
    [BREAKPOINTS[1]]: 425,
    [BREAKPOINTS[2]]: 350,
    [BREAKPOINTS[3]]: 386,
    [BREAKPOINTS[4]]: 535
  }
};

/**
 * Sizes strings map:  [sizes name]: [sizes query string]
 */
export const imageResponsiveSizes: { [key: string]: string } = Object.entries(imageResponsiveSizesRaw).reduce<{
  [key: string]: string;
}>(
  (sizesCollection, [key, definitions]) => ({
    ...sizesCollection,
    [key]: Object.entries(definitions)
      .reduce<string[]>((sizes, [vpSizeStr, imgSize]) => {
        const vpSize = parseInt(vpSizeStr, 10);
        const baseQuery = `only screen and (min-width: ${vpSize}px)`;
        return [
          ...sizes,
          ...(vpSize > 0
            ? retinaQueries
                .reduce<string[]>(
                  (queries, query) => [
                    ...queries,
                    `(${baseQuery} and ${query}) ${getImageSizeThreshold(imgSize * 2)}px`
                  ],
                  [`(${baseQuery}) ${getImageSizeThreshold(imgSize)}px`]
                )
                .map((query, i) => `${query}`)
            : ['100vw'])
        ];
      }, [])
      .join(',')
  }),
  {}
);
